import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

import { makeLogger } from "@/shared/consola";
// eslint-disable-next-line no-unused-vars
const logger = makeLogger("coffee-cart.service");

const COFFEE_ENDPOINT = `/coffees`;

export const coffeeCartService = {
    getECProducts() {
        return new Promise((resolve, reject) => {
            ajaxCall
                .get(`${COFFEE_ENDPOINT}/get-easy-cart-products`)
                .then((data) => {
                    logger.trace("getECProducts", "data", data);
                    resolve({ ...data, message: "SUCCESS" });
                })
                .catch((error) => {
                    if (error.errorToken?.startsWith?.("ERR_INT_EASY_CART")) {
                        logger.trace("getECProducts", "error", error);
                        resolve({ message: error.errorToken });
                    } else {
                        reject(error);
                    }
                });
        });
    },
    getECProduct(ecProductId) {
        return new Promise((resolve, reject) => {
            ajaxCall
                .get(`${COFFEE_ENDPOINT}/get-easy-cart-products/${ecProductId}`)
                .then((data) => {
                    logger.trace("getECProducts", "data", data);
                    resolve({ ...data, message: "SUCCESS" });
                })
                .catch((error) => {
                    if (error.errorToken?.startsWith?.("ERR_INT_EASY_CART")) {
                        logger.trace("getECProducts", "error", error);
                        resolve({ message: error.errorToken });
                    } else {
                        reject(error);
                    }
                });
        });
    },
    setDynamicPrice({ id, enabled }) {
        return ajaxCall
            .post(`${COFFEE_ENDPOINT}/set-easy-cart-dynamic-price`, { id, enabled })
            .catch(handleErrorByMessage());
    },
};
